import { render, staticRenderFns } from "./productProfitUser.vue?vue&type=template&id=92854412"
import script from "./productProfitUser.vue?vue&type=script&lang=js"
export * from "./productProfitUser.vue?vue&type=script&lang=js"
import style0 from "./productProfitUser.vue?vue&type=style&index=0&id=92854412&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports